const TOOLBAR_PARTS = {
    BLOCKS_ONLY: 'blocks',
    BLOCKS_WITH_FONT: 'blocks fontfamily fontsize',
    BASIC_TEXT: 'bold italic underline strikethrough',
    FULL_TEXT: 'bold italic underline strikethrough forecolor backcolor',
    ALIGN: 'alignleft aligncenter alignright alignjustify',
    LISTS_BASIC: 'bullist numlist',
    LISTS_FULL: 'bullist numlist outdent indent',
    MEDIA: 'table image media link',
    ACTIONS: 'removeformat code fullscreen',
} as const;

export const USER_TOOLBAR_OPTIONS = [
    TOOLBAR_PARTS.BLOCKS_ONLY,
    TOOLBAR_PARTS.BASIC_TEXT,
    TOOLBAR_PARTS.LISTS_BASIC,
].join(' | ');

export const ADMIN_TOOLBAR_OPTIONS = [
    TOOLBAR_PARTS.BLOCKS_WITH_FONT,
    TOOLBAR_PARTS.FULL_TEXT,
    TOOLBAR_PARTS.ALIGN,
    TOOLBAR_PARTS.LISTS_FULL,
    TOOLBAR_PARTS.MEDIA,
    TOOLBAR_PARTS.ACTIONS,
].join(' | ');
